import { useState, useEffect } from 'react';

export const useResponsiveSlider = () => {
  const [sliderLimit, setSliderLimit] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 700) {
        setSliderLimit(1);
      } else if (width < 1024) {
        setSliderLimit(3);
      } else {
        setSliderLimit(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { sliderLimit };
};
